import { Dispatch } from "redux";

import { Query } from "../../hooks/QueryHooks";
import {
  QUERY_INIT,
  CONFIG_INIT,
  GAME_CONFIG_LOADED,
} from "./actionIdentifiers";
import { State } from "../store";
import { get } from "./../../util/Path";

export const queryInit = (query: Query) => {
  const grade = Number(query.grade) || null;
  const unit = Number(query.unit) || null;
  const game = Number(query.game) || null;

  return {
    type: QUERY_INIT,
    payload: { grade, unit, game },
  };
};

export const configInit = () => {
  return async (dispatch: Dispatch<any>, getState: () => State) => {
    const res = await get("config/config.json");
    const { webUrl } = res.data;

    dispatch({ type: CONFIG_INIT, payload: { webUrl } });
  };
};

export const gameConfigLoad = () => {
  return { type: GAME_CONFIG_LOADED };
};
